import EditBreakDuration from './EditBreakDuration';

export default EditBreakDuration;
